'use strict';
angular.module('programme')

.directive('carouselMirror', function () {
    return {
        restrict: 'A',
        link: function (scope, element)
        {
            var carouselScope = element.isolateScope();

            scope.mirrorSlide = function (nextSlideIndex, direction)
            {
                carouselScope.select(carouselScope.slides[nextSlideIndex], direction);
            };
        }
    };
});
